import { Cat_Indices_Response } from '@opensearch-project/opensearch/api/cat/indices'
import { Indices_GetMapping_Response } from '@opensearch-project/opensearch/api/indices/getMapping'

import { sendRequest } from '@/services/dataSources/axiosConfig'
import { RequestProps } from '@/services/dataSources/types'
import { AsyncApiResponse } from '@/models/apiResponse'
import {
  CreateSellTreezRequest,
  SellTreez,
  UpdateSellTreezRequest,
  Workflow,
} from '@/models/sellTreez'
import { Record } from '@/models/record'
import { CreateIndexRequest } from '@/models/indices'

import { SellTreezInterface } from '../interfaces/sell-treez'

class SellTreezServiceImplementation implements SellTreezInterface {
  async getAllSellTreez(): AsyncApiResponse<SellTreez[]> {
    const request: RequestProps = {
      get: {
        path: '/selltreez',
      },
    }
    return await sendRequest<SellTreez[]>(request)
  }

  async getSellTreezDetail(id: string): AsyncApiResponse<SellTreez> {
    const request: RequestProps = {
      get: {
        path: `/selltreez/${id}`,
      },
    }
    return await sendRequest<SellTreez>(request)
  }

  async getSellTreezHistory(id: string): AsyncApiResponse<Record[]> {
    const request: RequestProps = {
      get: {
        path: `/selltreez/${id}/history`,
      },
    }
    return await sendRequest<Record[]>(request)
  }

  async createSellTreez(data: CreateSellTreezRequest): AsyncApiResponse<boolean> {
    const request: RequestProps = {
      post: {
        path: `/selltreez`,
        body: data,
      },
    }
    return await sendRequest<boolean>(request)
  }

  async updateSellTreez(data: UpdateSellTreezRequest, id: string): AsyncApiResponse<boolean> {
    const request: RequestProps = {
      put: {
        path: `/selltreez/${id}`,
        body: data,
      },
    }
    return await sendRequest<boolean>(request)
  }

  async getSellTreezIndexes(id: string): AsyncApiResponse<Cat_Indices_Response> {
    const request: RequestProps = {
      get: {
        path: `/selltreez/${id}/indexes`,
      },
    }
    return await sendRequest<Cat_Indices_Response>(request)
  }

  async getSellTreezIndexMappings(
    sellTreezId: string,
    indexName: string,
  ): AsyncApiResponse<Indices_GetMapping_Response> {
    const request: RequestProps = {
      get: {
        path: `/selltreez/${sellTreezId}/indexes/${indexName}/mapping`,
      },
    }
    return await sendRequest<Indices_GetMapping_Response>(request)
  }

  async createSellTreezIndex(
    sellTreezId: string,
    data: CreateIndexRequest,
  ): AsyncApiResponse<boolean> {
    const request: RequestProps = {
      post: {
        path: `/selltreez/${sellTreezId}/indexes`,
        body: data,
      },
    }
    return await sendRequest<boolean>(request)
  }

  async updateSellTreezIndexMapping(
    sellTreezId: string,
    data: CreateIndexRequest,
  ): AsyncApiResponse<boolean> {
    const request: RequestProps = {
      put: {
        path: `/selltreez/${sellTreezId}/indexes`,
        body: data,
      },
    }
    return await sendRequest<boolean>(request)
  }

  async getSellTreezWorkflows(id: string): AsyncApiResponse<Workflow[]> {
    const request: RequestProps = {
      get: {
        path: `/selltreez/${id}/workflow`,
      },
    }
    return await sendRequest<Workflow[]>(request)
  }
}

export const SellTreezService = new SellTreezServiceImplementation()
